export const dimensions = {
  none: "0rem",
  px: "0.0625rem",
  xxxs: "0.0625rem",
  xxs: "0.125rem",
  xs: "0.25rem",
  sm: "0.375rem",
  md: "0.5rem",
  lg: "0.75rem",
  xl: "1rem",
  "2xl": "1.5rem",
  "3xl": "2rem",
  "4xl": "2.5rem",
  "5xl": "3rem",
  "6xl": "3.5rem",
  "7xl": "4rem",
  "8xl": "4.5rem",
  "9xl": "5rem",
};

export const borderRadius = {
  none: dimensions.none,
  xs: dimensions.xs,
  sm: dimensions.md,
  md: dimensions.xl,
  lg: dimensions["2xl"],
};

export const borderWidth = {
  xs: dimensions.px, // 1px
  sm: dimensions.xxs, // 2px
  md: dimensions.xs, // 4px
  lg: dimensions.sm, // 6px
};

export const widths = {
  sm: "32rem", // 512px - standard auth card width (rounded from 533px/33.3125rem)
  md: "40rem", // 640px - narrow content column
  lg: "64rem", // 1024px - wide content column
  xl: "80rem", // 1280px - max content width
};

export const sidebarWidths = {
  expanded: "14.25rem", // 228px - expanded sidebar width
  minimized: dimensions["9xl"], // 3.5rem - minimized sidebar width
};

export const componentHeights = {
  buttonSm: "2rem", // 32px - small button height
  buttonMd: "2.5rem", // 4px - standard button height
  buttonLg: "3.5rem", // 56px - large button height used on auth CTAs
  homeTopCards: "9rem",
};

export default {
  componentHeights,
  borderRadius,
  borderWidth,
  sidebarWidths,
  spacing: dimensions,
  widths,
};
